import { render, staticRenderFns } from "./Accountmanage.vue?vue&type=template&id=b05e7f5a&scoped=true&"
import script from "./Accountmanage.vue?vue&type=script&lang=js&"
export * from "./Accountmanage.vue?vue&type=script&lang=js&"
import style0 from "./Accountmanage.vue?vue&type=style&index=0&id=b05e7f5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b05e7f5a",
  null
  
)

export default component.exports